// extracted by mini-css-extract-plugin
export var container = "worker-module--container--IGN7q";
export var memorialWall = "worker-module--memorialWall--DhxVq";
export var memorialWallText = "worker-module--memorialWallText--i-Sxg";
export var currentWorkerText = "worker-module--currentWorkerText--zxsXA";